function Segment(item) {
  if (process.env.REACT_APP_ON_SEGMENT === 'true') {
    window.onbeforeunload = null;
    window.addEventListener('beforeunload', (e) => {
      e.preventDefault();
      window.analytics.track('Homepage Viewed', {
        Browsed: item,
      });
    });
  }
}

export default Segment;
